<template>
  <div
    :class="{'mobile-size': isMobile}"
    class="element-container">
    <div class="image-container" :class="[{ 'img-empty': !data[fieldName]}, imageSize]">
      <img
        class="image"
        v-if="imageSource"
        :src="imageSource" />
      <div class="empty-container" v-if="!imageSource">
        <div class="detail">{{noImageText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    fieldName: {
      type: String,
      default: 'coverImage',
    },
    thumborSize: {
      type: String,
      default: 'cover1280w720h',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imageSource() {
      if (this.data[this.fieldName]) {
        if (typeof this.data[this.fieldName] === 'string') {
          return this.data[this.fieldName];
        }

        if (typeof this.data[this.fieldName] === 'object') {
          if (this.data[this.fieldName].type === 'thumbor') {
            if (this.thumborSize === 'original') {
              return this.generateOriginalSource(this.data[this.fieldName].baseUrl);
            }
            return _.get(this.data[this.fieldName].urls, this.thumborSize, null);
          }
          if (this.data[this.fieldName].type === 'thaipbsProgram') {
            return _.get(this.data[this.fieldName].urls, this.thumborSize, null);
          }
          if (_.isEmpty(this.data[this.fieldName])) {
            return this.defaultSource;
          }
          return _.get(this.data[this.fieldName].urls, this.thumborSize, null);
        }
      }

      if (this.defaultSource) {
        return this.defaultSource;
      }
      return null;
    },
    noImageText() {
      if (this.isMobile) {
        return 'ไม่ได้เลือกภาพสำหรับมือถือ';
      }
      return 'ไม่มีภาพแบนเนอร์';
    },
    imageSize() {
      switch (this.thumborSize) {
        case 'cover970w250h':
          return 'desktop-banner';
        case 'cover336w280h':
          return 'mobile-banner';
        case 'cover350w625h':
          return 'mobile-popup';
        default:
          return '';
      }
    },
  },
  methods: {
    generateOriginalSource(mediaBaseUrl) {
      const idx = mediaBaseUrl.indexOf('/images');
      return `//${mediaBaseUrl.slice(0, idx + 7)}/original${mediaBaseUrl.slice(idx + 7, mediaBaseUrl.length)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.element-container {
  display: flex;
  flex: 1;

  .image-container {
    width: 100%;
    padding-top: 56.25%;
    position: relative;
    overflow: hidden;

    .image {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      img {
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: 0;
      }
    }
  }

  .desktop-banner{
    padding-top: 25.77%;
  }

  /* .mobile-size {
    padding-top: 83.33%;
  } */

  .empty-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    color: $gray-400;
    text-align: center;
    font-size: $font-size-sm;
    font-family: $font-family-base;
  }
  .img-empty {
    background-color: $gray-700;
    position: relative;

  }

  &.mobile-size {
    width: 270px;
    .mobile-banner {
      padding-top: 83.33%;
      /* padding-top: 0; */
    }
    .mobile-popup {
      padding-top: 177.78%;
    }
  }
}

</style>
